import { unref } from 'vue'

function filterLocaleSetting(localeSetting, locale, defaultLocale, key) {
  let type = 'text'

  if (key.toUpperCase().includes('URL')) {
    type = 'url'
  }

  const actualLocale = unref(locale)
  const actualDefaultLocale = unref(defaultLocale)

  const currentLocaleData = localeSetting?.find((set) => set.locale === actualLocale) || {}
  const defaultLocaleData = localeSetting?.find((set) => set.locale === actualDefaultLocale) || {}

  // 這邊只有回傳圖片路徑或是文字
  if (type === 'url') {
    const url = currentLocaleData?.[key]?.length > 0 ? currentLocaleData?.[key] : defaultLocaleData?.[key] || []

    if (url && Array.isArray(url) && url.length > 0) {
      if (key === 'descriptionUrl') {
        return url || []
      }
      return (url[0] || {}).url
    } else {
      return ''
    }
  } else {
    return currentLocaleData?.[key] || defaultLocaleData?.[key] || ''
  }
}

export default filterLocaleSetting
